import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "", ...rest }) => (
  <p className={`eyebrow text-violet-600 ${className}`} {...rest}>
    {children}
  </p>
);

export const SectionTitle = ({ eyebrow, title, sub, align = "left", testId }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <Eyebrow>{eyebrow}</Eyebrow>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 data-testid={testId} className="font-display mt-4 text-3xl font-bold leading-[1.05] tracking-tight text-ink sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base leading-relaxed text-ink-2 sm:text-lg">{sub}</p>
      </Reveal>
    )}
  </div>
);
